import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle } from "lucide-react";

export const HOME_FAQS = [
  {
    q: "Apakah ini obat?",
    a: "Bukan, ini minuman herbal alami untuk mendukung gaya hidup sehat.",
  },
  {
    q: "Bisa diminum setiap hari?",
    a: "Bisa, selama dikonsumsi secara wajar.",
  },
  {
    q: "Bisa diminum dingin?",
    a: "Bisa, cocok dinikmati hangat maupun dingin.",
  },
];

const FaqSection = () => (
  <section
    aria-labelledby="faq-heading"
    className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-12 sm:pb-16"
    data-testid="faq-section"
  >
    <div className="flex items-center gap-3 mb-5">
      <span className="inline-flex w-10 h-10 rounded-xl bg-emerald-50 text-emerald-700 items-center justify-center">
        <HelpCircle className="w-5 h-5" />
      </span>
      <h2
        id="faq-heading"
        className="font-display text-2xl sm:text-3xl font-semibold text-stone-900"
      >
        Tanya Jawab Singkat
      </h2>
    </div>

    <Accordion
      type="single"
      collapsible
      className="bg-white border border-stone-200 rounded-2xl shadow-sm divide-y divide-stone-100 overflow-hidden"
    >
      {HOME_FAQS.map((f, i) => (
        <AccordionItem
          key={i}
          value={`q${i}`}
          className="border-0 px-5 sm:px-6"
        >
          <AccordionTrigger
            className="text-left text-base sm:text-lg font-medium text-stone-900 hover:no-underline py-4"
            data-testid={`faq-q-${i}`}
          >
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-stone-600 text-base pb-4">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);

export default FaqSection;
